import { login, findUserInfo, logout } from '@/api/login'
import { clearStorage, getToken, setToken } from '@/utils/token'

const user = {
  state: {
    id: 0,
    empName: '',
    role: '',
    avatar: '',
    funeralHomeName: '',
    screenType: '',
    permissions: [],
    tenantServicePlace: ''
  },

  mutations: {
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_USER_INFO: (state, {
      id,
      empName,
      avatar,
      funeralHomeName,
      screenType,
      role,
      tenantServicePlace
    }) => {
      state.id = id
      state.empName = empName
      state.avatar = avatar
      state.funeralHomeName = funeralHomeName
      state.screenType = screenType
      state.role = role
      state.tenantServicePlace = tenantServicePlace
    },
    CLEAR_USER_INFO: (state) => {
      state.id = 0
      state.empName = ''
      state.role = ''
      state.avatar = ''
      state.funeralHomeName = ''
      state.screenType = ''
      state.tenantServicePlace = ''
    }
  },

  actions: {
    // 清除登录信息
    ClearLoginInfo({ commit }) {
      return new Promise(resolve => {
        commit('SET_PERMISSIONS', [])
        commit('CLEAR_USER_INFO', [])
        clearStorage()
        resolve()
      })
    },

    // 登录
    Login({ dispatch, commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(res => {
          if (res.code === 0) {
            dispatch('ClearLoginInfo')
            setToken(res.data.token)
            resolve(res)
          } else {
            reject(res)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    FindUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        findUserInfo().then(res => {
          if (res.code === 0) {
            const { data } = res
            commit('SET_PERMISSIONS', data.permissions)
            commit('SET_USER_INFO', {
              id: data.id,
              empName: data.emp_name,
              avatar: data.avatar,
              funeralHomeName: data.funeral_home_name,
              screenType: data.screen_type,
              role: data.role,
              tenantServicePlace: data.tenant_service_place
            })
            resolve(res)
          } else {
            reject(res)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout({ dispatch }) {
      return new Promise((resolve) => {
        logout(getToken()).then((res) => {
          if (res.code === 0) {
            dispatch('ClearLoginInfo')
            resolve(res)
          }
        }).catch((err) => {
          resolve(err)
        }).finally(() => {
        })
      })
    }
  }
}

export default user
